import { map as _map } from 'lodash-es';
import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';
import SpeedIcon from '@mui/icons-material/Speed';
import SelectField from '../forms/select-field';
import { eventDistances } from '../../utils/events';
import type { EventFormValues } from './form';

const useStyles = makeStyles()((theme) => ({
  label: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    fontSize: 16,
  },
}));

const EventFormDistances = (props) => {
  const { classes } = useStyles();
  const { values: { eventType } } = useFormikContext<EventFormValues>();

  const options = useMemo(() => _map(eventDistances, ({ name }, value) => ({
    label: name,
    value,
  })), []);

  if (eventType !== 'RIDE') {
    return null;
  }

  return (
    <SelectField
      name="distance"
      label={(
        <span className={classes.label}>
          <SpeedIcon className={classes.icon} />
          Distance (optional)
        </span>
      )}
      options={options}
      placeholder="Choose One"
      {...props}
    />
  );
};

export default EventFormDistances;
